export default __webpack_public_path__ + "static/media/people.b1a03f94.svg";